import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dashboardActions, userActions } from '../../../_actions';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showProfileBox: false,

      showDropdown: false
    }
  }
  componentDidMount() {
    // this.props.dispatch(dashboardActions.getClientProfile());
  }

  openProfile = (check) => {
    this.setState({ showProfileBox: !check })

    setTimeout(() => {
      this.setState({ showProfileBox: false })
    }, 4000)
  }
  handleLogout = () => {
    let { CurrentSurveyCode } = this.props;
    this.props.dispatch(userActions.logoutSession(CurrentSurveyCode));
  }


  render() {
    let { dashboard, CurrentLanguageName, getLanguageData, handleLanguage, showLanguageModal, openLanguageModal } = this.props;
    let { showProfileBox } = this.state;
    let { ClientProfileData } = dashboard;
    console.log('ClientProfileData:', ClientProfileData)

    let ProfileName = '';

    let ProfileGender = '';
    let companyName ="";

    let ClientProfile = ClientProfileData && ClientProfileData.profile?ClientProfileData.profile:{}

    if (ClientProfile && ClientProfile.name) {
      let nameGender = "";
      if (ClientProfile && ClientProfile.Gender) {
        nameGender = ClientProfile.Gender;
      }
      else if (ClientProfile && ClientProfile.gender) {
        nameGender = ClientProfile.gender;
      }

      ProfileGender = nameGender;
      ProfileName = ClientProfile.name;

    }

    if(ClientProfile && ClientProfile.companyId && ClientProfile.companyId.name){
      companyName = ClientProfile.companyId.name;
    }


    let surveyLogo = "";
    let ClientSurvey = ClientProfileData && ClientProfileData.survey?ClientProfileData.survey:{}
    if(ClientSurvey && ClientSurvey.logo){
      surveyLogo = ClientSurvey.logo;
    }

    console.log("surveyLogo-ID--------->",surveyLogo)
    return (
      <>
        <header className=" w-full flex justify-between items-center  md:px-6 px-4 bg-white  border-b " style={{ height: '4rem' }}>
          <div className='flex itmes-center lg:space-x-0 space-x-4'>
            <div className="flex items-center space-x-4 ">
            <img src={surveyLogo?surveyLogo:'/img/logo/happypluslogo.png'} className='h-12 object-cover'/>

              <span className='border py-1 px-2 text-gray-500 text-sm rounded-md'>{companyName ? companyName : ""}</span>
            </div>
          </div>
          <div className="flex items-center justify-between py-3">
            <div className="lg:flex hidden border-r pr-3 mx-2 items-center ">
              
              
              {/* <h1 onClick={() => { openLanguageModal(showLanguageModal); this.openProfile(!false); }}
              className="text-sm cursor-pointer">{CurrentLanguageName}</h1><span onClick={() => { openLanguageModal(showLanguageModal); this.openProfile(!false); }}
                className="cursor-pointer material-symbols-outlined">arrow_drop_down</span>

              {showLanguageModal ?
                <>
                  <div className="absolute top-12 right-30 bg-white shadow-2xl w-32 z-10  overflow-hidden  lang text-xs rounded-lg ">
                    {CurrentLanguageName !== "English" ?
                      <>
                        <span onClick={() => handleLanguage({
                          "shortName": "en",
                          "name": "English"
                        })} className="cursor-pointer block  w-full hover:bg-blue-50 py-2 px-4 flex items-center">
                          <img alt='language' src={"https://cdn-icons-png.flaticon.com/512/330/330459.png"}
                            className="w-4 mr-2" />
                          {"English"}
                        </span>
                      </>
                      : null}
                  </div>
                </>
                : null} */}


                

            </div>


            <div className="relative flex items-center ">
              <button onClick={() => this.openProfile(showProfileBox)} className="relative block h-10 w-10 ml-2 rounded-full overflow-hidden  focus:outline-none">
                {/* <img className="h-full w-full object-cover" src="https://4.bp.blogspot.com/-szJiVBCNYq8/XHPIf2urmgI/AAAAAAAAA3Q/rgzjBI6jxFsORJjM0XxQ8kHV5r2wLzipgCEwYBhgL/s1600/IMG_20190225_160623.jpg" alt="Your avatar" /> */}

                {(ProfileGender === "Female") ?
                  <img className="h-full w-full object-cover" src="img/profile/user2.png" alt="Your avatar" />
                  :
                  <img className="h-full w-full object-cover" src="img/profile/user1.png" alt="Your avatar" />
                }


              </button>
              <div onClick={() => this.openProfile(showProfileBox)} className="ml-2 lg:flex items-center hidden cursor-pointer"><h1 className="text-sm text-gray-700 font-medium">{ProfileName}</h1><span className="material-symbols-outlined">arrow_drop_down</span></div>

              {showProfileBox ?
                <>
                  {/* <div className="bg-white rounded-sm shadow-xl absolute top-14 right-0 w-44 py-2 text-sm">
                  <p onClick={() => this.openProfile(showProfileBox)} className="text-gray-500  truncate cursor-pointer hover:bg-gray-200 p-3 font-medium">{ProfileName}</p>
                  <span onClick={() => this.handleLogout()} className="hover:text-red-600 text-red-500 py-2 hover:font-medium block cursor-pointer hover:bg-gray-200 p-3">Logout</span>
                </div> */}

                  <div className="bg-white rounded-sm shadow-2xl p-4 absolute top-12 right-0 w-44 rounded-lg  ">
                    <p onClick={() => this.openProfile(showProfileBox)} className="text-base truncate font-medium">{ProfileName}</p>
                    <span onClick={() => this.handleLogout()} className="text-sm hover:text-red-600 text-blue-500 py-2  block flex items-center cursor-pointer">
                      <span className=" material-symbols-outlined mr-2">logout</span> Logout</span>
                  </div>

                </>
                : null}


            </div>
          </div>
        </header>
      </>
    );
  }
}
function mapStateToProps(state) {
  // ////console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { user, dashboard } = state;
  return {
    loggingIn,
    user,
    dashboard
  };
}
export default connect(mapStateToProps)(Header);